(function () {
  function getModal() {
    return document.getElementById('sar-modal');
  }

  function openModal(html) {
    var modal = getModal();
    var content = document.getElementById('sar-modal-content');
    if (!modal || !content) return;
    content.innerHTML = html || '';
    modal.style.display = 'flex';
    // wait a frame so the browser registers display:flex before animating in
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    });
  }

  window.sarCloseModal = function () {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    // match the CSS transition duration before hiding
    setTimeout(function () {
      modal.style.display = 'none';
    }, 250);
  };

  // Listen on the document so triggers keep working if the product
  // section re-renders (for example after picking a colour or size).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sar-popup-trigger');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-content'));
      return;
    }
    if (e.target === getModal()) window.sarCloseModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.sarCloseModal();
  });
})();